function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M19 7c0 .18-.01.35-.03.52a5.922 5.922 0 01-1.73 3.72A5.944 5.944 0 0113 13H9.87c-.5 0-.92.37-.99.86l-.76 5.28c-.06.39-.34.71-.71.81-.09.04-.18.05-.28.05H5.18a.998.998 0 01-.99-1.16L6.58 4.51A2.997 2.997 0 019.54 2H14c2.76 0 5 2.24 5 5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21 11c0 1.38-.56 2.63-1.46 3.54-.91.9-2.16 1.46-3.54 1.46h-2.15a1 1 0 00-.99.84l-.72 4.32a1 1 0 01-.99.84H8.22a.95.95 0 01-.48-.12c-.22-.12-.08-.41.16-.51.9-.29 1.56-1.06 1.7-2.02l.64-4.42c.04-.25.25-.43.49-.43H13c2.01 0 3.9-.78 5.3-2.19.83-.82 1.45-1.83 1.81-2.92.08-.25.41-.3.52-.07.24.52.37 1.08.37 1.68z"
})));